import type { IconData } from '@stacksjs/iconify-core'

export const la4x3: IconData = {
  "body": "<defs><clipPath id=\"SVG9mrxwcPk\"><path fill-opacity=\".7\" d=\"M0 0h640v480H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVG9mrxwcPk)\"><path fill=\"#ce1126\" d=\"M-40 0h720v480H-40z\"/><path fill=\"#002868\" d=\"M-40 119.3h720v241.4H-40z\"/><path fill=\"#fff\" d=\"M423.4 240a103.4 103.4 0 1 1-206.8 0a103.4 103.4 0 1 1 206.8 0\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default la4x3
